package devxertech.com.pages.career.careerEmployee

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Span

@Composable
fun CareerEmployee() {
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .margin(top = if (breakpoint > Breakpoint.MD) 20.px else 0.px)
            .padding(top = if (breakpoint > Breakpoint.MD) 0.px else 20.px),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        FieldTitleTextNormalSimple(
            text = "Employee Benefits",
            color = sitePalette.commonSecondaryButtonColor.rgb,
            fontSize = 18.px,
            textAlign = TextAlign.Center,
            textTransform = TextTransform.Uppercase,
            asH2 = true,

        )
        Row(
            modifier = Modifier.flexWrap(FlexWrap.Wrap),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Span (attrs = Modifier.textAlign(TextAlign.Center).toAttrs()){
                FieldTitleTextNormalSimple(
                    text = "Trusted, Nurtured & Driven to ",
                    color = sitePalette.primary.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    fontSize = if (breakpoint >= Breakpoint.LG) 30.px else 22.px,
                    fontWeight = 700,
                    textTransform = TextTransform.Uppercase
                )
                FieldTitleTextNormalSimple(
                    text = "Succeed",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    fontSize = if (breakpoint >= Breakpoint.LG) 30.px else 22.px,
                    fontWeight = 700,
                    textTransform = TextTransform.Uppercase
                )
            }
        }

        Row(modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.Center) {
            Image(
                src = Res.Image.career_succeed, description = "Career growth illustration",
                modifier = Modifier.margin(topBottom = 20.px)
                    .fillMaxWidth(if(window.screen.width > 475) 63.percent else 90.percent)

            )
        }
//        Box(modifier = Modifier
//                .fillMaxWidth()
//                .margin(top = if (breakpoint >= Breakpoint.MD) 0.px else (-100).px),
//            contentAlignment = Alignment.Center
//        ) {
//            Image(
//                src = Res.Image.career_succeed,
//                modifier = Modifier
//                    .fillMaxWidth(80.percent)
//                    .height(
//                        when (breakpoint) {
//                            Breakpoint.LG -> 300.px
//                            Breakpoint.MD -> 300.px
//                            Breakpoint.SM -> 250.px
//                            else -> 394.px
//                        }
//                    )
//                    .margin(topBottom = if (breakpoint > Breakpoint.MD) 50.px else 0.px)
//            )
//        }
    }
}
